import { useTranslation } from "react-i18next";
import beaconGif from "@/assets/generated (1080 x 1080 px) (2).gif";

export const BeaconSection = () => {
  const { t } = useTranslation();
  return (
    <div className="relative w-full flex justify-center items-center -mt-2 pt-0 pb-2">
      <img src={beaconGif} alt={t('components.beacon.alt')} className="w-44 h-44 sm:w-52 sm:h-52 object-contain" />
    </div>
  );
};
